<template>
  <notice-component/>
</template>

<script>
import NoticeComponent from '@/spa/components/board/notice/BoardNotice';

export default {
  name: 'NoticePage',
  components: {
    NoticeComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/NoticePage.vue